
import React from 'react'
import JobInterviewContext from '../../../contexts/JobInterviewContext'
import { DisplayJobInterviewQuestions } from "../jobinterview/DisplayJobInterviewQuestions"

import "./jobinterview.css"

export const JobInterviewQuestions = () => {

  let {
    topics, 
    uberTopics,
  } = React.useContext(JobInterviewContext);

  return (

    <div className="homeContainer" style = {{minHeight:'300px'}}>

       {/* Render uberTopics if they exist */}
      { (uberTopics.some(arr => arr.length > 0))  > 0 && (
        <div>
          {uberTopics.map((topicGroup, groupIndex) => (
            <div key={`topic-group-${groupIndex}`}>
              
               <h3>  {topics?.[groupIndex]?.subtopic}</h3>
              <div>
                {topicGroup.map((question, questionIndex) => (
                  <DisplayJobInterviewQuestions 
                    key={`question-${groupIndex}-${questionIndex}`} 
                    text={question} 
                    index={groupIndex}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

     

      <br></br>
    </div>
  )
}




